import React from 'react';

const RedStar = () => {
  return <span className='text-red-600'>*</span>;
};

export default RedStar;
